import { c as _c } from "react/compiler-runtime";
import { featureFlagAtom, FeatureFlagEnum } from '@states/featureFlagAtom';
import { useJotaiValue } from '@states/jotai/hooks';
export type TUseFeatureFlagsReturn = {
  isFeatureEnabled: (flag: FeatureFlagEnum) => boolean;
  isConsumerActivityLogEnabled: boolean;
  isPayByBankEnabled: boolean;
  isPayByBankAutoRefreshEnabled: boolean;
  isSavesEnabled: boolean;
  isTransactionActionsEnabled: boolean;
  isDeferredCallRedirectEnabled: boolean;
  isTrainingEnabled: boolean;
  isPostDateOnMissingDownPaymentEnabled: boolean;
  isCustomerOwnsVehicleEnabled: boolean;
  isStopTransferEnabled: boolean;
  isNotesV2Enabled: boolean;
  isDarkModeToggleEnabled: boolean;
  isDownloadPrrBreakdownEnabled: boolean;
  isCarfaxAllReportsEnabled: boolean;
  isEnduranceClaimsHistoryEnabled: boolean;
  isFavoriteConsumersEnabled: boolean;
  isHomeCancellationSmsDeliveryEnabled: boolean;
  isInteractionHistoryEnabled: boolean;
  isQuoteActivityLogEnabled: boolean;
};
export function useFeatureFlags() {
  const $ = _c(60);
  const {
    featureFlags
  } = useJotaiValue(featureFlagAtom);
  let t0;
  let t1;
  if ($[0] !== featureFlags) {
    t0 = flag => featureFlags.includes(flag);
    t1 = featureFlags.includes(FeatureFlagEnum.ConsumerActivityLog);
    $[0] = featureFlags;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  let t2;
  if ($[3] !== featureFlags) {
    t2 = featureFlags.includes(FeatureFlagEnum.PayByBank);
    $[3] = featureFlags;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== featureFlags) {
    t3 = featureFlags.includes(FeatureFlagEnum.PayByBankAutoRefresh);
    $[5] = featureFlags;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== featureFlags) {
    t4 = featureFlags.includes(FeatureFlagEnum.Saves);
    $[7] = featureFlags;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== featureFlags) {
    t5 = featureFlags.includes(FeatureFlagEnum.TransactionActions);
    $[9] = featureFlags;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== featureFlags) {
    t6 = featureFlags.includes(FeatureFlagEnum.DeferredCallRedirect);
    $[11] = featureFlags;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== featureFlags) {
    t7 = featureFlags.includes(FeatureFlagEnum.Training);
    $[13] = featureFlags;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== featureFlags) {
    t8 = featureFlags.includes(FeatureFlagEnum.PostDateOnMissingDownPayment);
    $[15] = featureFlags;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== featureFlags) {
    t9 = featureFlags.includes(FeatureFlagEnum.CustomerOwnsVehicle);
    $[17] = featureFlags;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== featureFlags) {
    t10 = featureFlags.includes(FeatureFlagEnum.StopTransfer);
    $[19] = featureFlags;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== featureFlags) {
    t11 = featureFlags.includes(FeatureFlagEnum.NotesV2);
    $[21] = featureFlags;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== featureFlags) {
    t12 = featureFlags.includes(FeatureFlagEnum.DarkModeToggle);
    $[23] = featureFlags;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== featureFlags) {
    t13 = featureFlags.includes(FeatureFlagEnum.DownloadPrrBreakdown);
    $[25] = featureFlags;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== featureFlags) {
    t14 = featureFlags.includes(FeatureFlagEnum.CarfaxAllReports);
    $[27] = featureFlags;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== featureFlags) {
    t15 = featureFlags.includes(FeatureFlagEnum.EnduranceClaimsHistory);
    $[29] = featureFlags;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== featureFlags) {
    t16 = featureFlags.includes(FeatureFlagEnum.FavoriteConsumersDevOnly);
    $[31] = featureFlags;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== featureFlags) {
    t17 = featureFlags.includes(FeatureFlagEnum.HomeCancellationSmsDelivery);
    $[33] = featureFlags;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== featureFlags) {
    t18 = featureFlags.includes(FeatureFlagEnum.InteractionHistory);
    $[35] = featureFlags;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] !== featureFlags) {
    t19 = featureFlags.includes(FeatureFlagEnum.QuoteActivityLog);
    $[37] = featureFlags;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  let t20;
  if ($[39] !== t0 || $[40] !== t1 || $[41] !== t10 || $[42] !== t11 || $[43] !== t12 || $[44] !== t13 || $[45] !== t14 || $[46] !== t15 || $[47] !== t16 || $[48] !== t17 || $[49] !== t18 || $[50] !== t19 || $[51] !== t2 || $[52] !== t3 || $[53] !== t4 || $[54] !== t5 || $[55] !== t6 || $[56] !== t7 || $[57] !== t8 || $[58] !== t9) {
    t20 = {
      isFeatureEnabled: t0,
      isConsumerActivityLogEnabled: t1,
      isPayByBankEnabled: t2,
      isPayByBankAutoRefreshEnabled: t3,
      isSavesEnabled: t4,
      isTransactionActionsEnabled: t5,
      isDeferredCallRedirectEnabled: t6,
      isTrainingEnabled: t7,
      isPostDateOnMissingDownPaymentEnabled: t8,
      isCustomerOwnsVehicleEnabled: t9,
      isStopTransferEnabled: t10,
      isNotesV2Enabled: t11,
      isDarkModeToggleEnabled: t12,
      isDownloadPrrBreakdownEnabled: t13,
      isCarfaxAllReportsEnabled: t14,
      isEnduranceClaimsHistoryEnabled: t15,
      isFavoriteConsumersEnabled: t16,
      isHomeCancellationSmsDeliveryEnabled: t17,
      isInteractionHistoryEnabled: t18,
      isQuoteActivityLogEnabled: t19
    };
    $[39] = t0;
    $[40] = t1;
    $[41] = t10;
    $[42] = t11;
    $[43] = t12;
    $[44] = t13;
    $[45] = t14;
    $[46] = t15;
    $[47] = t16;
    $[48] = t17;
    $[49] = t18;
    $[50] = t19;
    $[51] = t2;
    $[52] = t3;
    $[53] = t4;
    $[54] = t5;
    $[55] = t6;
    $[56] = t7;
    $[57] = t8;
    $[58] = t9;
    $[59] = t20;
  } else {
    t20 = $[59];
  }
  return t20;
}